export default {"src":"/_next/static/media/WhoWeAre_049A.68ba98a2.JPG","height":690,"width":1920};